import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const LineOfCreditTransactionViewFragment = gql`
  fragment LineOfCreditTransactionViewFragment on LineOfCreditTransactionView {
    __typename
    date
    accountFrom
    accountTo
    amount {
      ...money
    }
    runningBalance {
      ...money
    }
    description
    status
  }
  ${money}
`;

const VlocReviewDetailsFragment = gql`
  fragment VlocReviewDetailsFragment on VlocReviewDetails {
    __typename
    amount
    id
    items {
      description
      id
      isClickable
      paymentSchedule {
        amount
        id
        installmentState
        title
      }
      title
    }
    titleAmount
  }
`;

const FetchLineOfCreditHistoryDetails = gql`
  query FetchLineOfCreditHistoryDetails($lineOfCreditId: String!) {
    lineOfCreditHistoryDetails(lineOfCreditId: $lineOfCreditId) {
      ... on LineOfCreditHistoryDetailsSuccess {
        lineOfCreditId
        lineOfCreditDetails {
          ...VlocReviewDetailsFragment
        }
        transactions {
          ...LineOfCreditTransactionViewFragment
        }
      }
      ... on LineOfCreditHistoryDetailsError {
        code
        message
        title
      }
    }
  }
  ${VlocReviewDetailsFragment}
  ${LineOfCreditTransactionViewFragment}
`;

export default FetchLineOfCreditHistoryDetails;
